// * 按照字符数算字符串长度
const strLen=(str)=> {
  const resultStr= str.replace(/[\u4E00-\u9FFF]/g,'aa')
  const resultCNArr= str.match(/[\u4E00-\u9FFF]/g)||[]
  const obj={
    characterStrLen:resultStr.length, // 字符总个数
    chineseLen:resultCNArr.length, // 中文总个数
  }
  console.log(obj)
  return obj
}

export default strLen